import AdsRules from './AdsRules';

export { AdsRules };
export default AdsRules;
